var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-container" }, [
    _c(
      "div",
      { staticClass: "menu-wrapper" },
      [
        _vm.$store.state.user.userType === 8
          ? [
              _vm._l(_vm.zhwy_routers, function(item) {
                return [
                  _c(
                    "div",
                    {
                      key: item.name,
                      staticClass: "menu__item",
                      on: {
                        click: function($event) {
                          return _vm.handleZhwyMenuSelect(item)
                        }
                      }
                    },
                    [
                      _c("svg-icon", {
                        staticClass: "iconStyle",
                        staticStyle: {
                          width: "50px",
                          height: "50px",
                          "margin-bottom": "2.1vh"
                        },
                        attrs: { "icon-class": item.icon }
                      }),
                      _c("span", { staticClass: "menu__item-text" }, [
                        _vm._v(_vm._s(item.title))
                      ])
                    ],
                    1
                  )
                ]
              })
            ]
          : !_vm.userTheme
          ? [
              _vm._l(_vm.admin_routers, function(item) {
                return [
                  !item.hidden && item.path !== "/"
                    ? _c(
                        "div",
                        {
                          key: item.name,
                          staticClass: "menu__item--default",
                          class: {
                            "menu__item-bigger":
                              _vm.admin_routers && _vm.admin_routers.length <= 3
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleMenuSelect(item)
                            }
                          }
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "iconStyle",
                            staticStyle: {
                              width: "50px",
                              height: "50px",
                              "margin-bottom": "2.1vh"
                            },
                            attrs: { "icon-class": item.meta.icon }
                          }),
                          _c("span", { staticClass: "menu__item-text" }, [
                            _vm._v(_vm._s(item.meta.title))
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              })
            ]
          : [
              _vm._l(_vm.admin_routers, function(item) {
                return [
                  !item.hidden && item.path !== "/"
                    ? _c(
                        "div",
                        {
                          key: item.name,
                          staticClass: "menu__item",
                          class: {
                            "menu__item-bigger":
                              _vm.admin_routers && _vm.admin_routers.length <= 3
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleMenuSelect(item)
                            }
                          }
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "iconStyle",
                            staticStyle: {
                              width: "50px",
                              height: "50px",
                              "margin-bottom": "2.1vh"
                            },
                            attrs: { "icon-class": item.meta.icon }
                          }),
                          _c("span", { staticClass: "menu__item-text" }, [
                            _vm._v(_vm._s(item.meta.title))
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              })
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }